document.addEventListener('DOMContentLoaded', function () {
  const discountElement = document.querySelector('.dynamic-discount'); // Элемент скидки
  const variantIdInput = document.querySelector('input[name="id"][data-product-secondary-select]'); // Поле с ID текущего варианта

  if (discountElement && variantIdInput) {
    const updateDiscount = () => {
      const selectedVariantId = parseInt(variantIdInput.value, 10); // ID текущего варианта
      const selectedVariant = Shopify.product.variants.find(v => v.id === selectedVariantId); // Находим текущий вариант

      if (selectedVariant && selectedVariant.compare_at_price > selectedVariant.price) {
        // Рассчитываем скидку
        const discount = Math.round(
          ((selectedVariant.compare_at_price - selectedVariant.price) / selectedVariant.compare_at_price) * 100
        );
        discountElement.textContent = `-${discount}%`; // Обновляем текст скидки
        discountElement.style.display = 'inline-block'; // Показываем элемент
      } else {
        discountElement.textContent = '';
        discountElement.style.display = 'none'; // Скрываем элемент, если нет скидки
      }
    };

    // Обновляем скидку при загрузке страницы
    updateDiscount();

    // Используем MutationObserver для отслеживания изменений ID текущего варианта
    const observer = new MutationObserver(() => {
      updateDiscount();
    });

    // Следим за изменениями атрибута "value" в поле variantIdInput
    observer.observe(variantIdInput, { attributes: true, attributeFilter: ['value'] });
  }
});









